import { type ReactNode } from 'react';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: string;
}

export function Drawer({ open, onClose, children, width = 'w-[640px]' }: DrawerProps) {
  if (!open) return null;
  return (
    <>
      <div className="fixed inset-0 bg-navy-900/40 z-40" onClick={onClose} />
      <div
        className={`fixed top-0 right-0 h-full ${width} bg-white shadow-2xl z-50 flex flex-col animate-drawer-in`}
        role="dialog"
        aria-modal="true"
      >
        {children}
      </div>
    </>
  );
}

export function DrawerCloseButton({ onClick }: { onClick: () => void }) {
  return (
    <button onClick={onClick} className="hover:opacity-70 transition" aria-label="Close drawer">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    </button>
  );
}
